import { createReducer } from '@mews/framework';
import { SETTINGS_ADDED } from '../actions/types';
import { EnterpriseFormValues } from '../types';

const INITIAL_STATE = {};

export default createReducer(INITIAL_STATE, {
    [SETTINGS_ADDED]: (state: EnterpriseFormValues, settings: EnterpriseFormValues) => ({
        ...state,
        ...settings,
    }),
});
